import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import SafeComponent from "./SafeComponent.jsx";
import Hotel_img from "../Images/hotelimg.jpg"
import noimg from "../Images/noimg.jpg"
// import "./ResortCard.css";

const ResortCard = ({ resort }) => {
  const navigate = useNavigate();
    console.log("data in resort card : ",resort)
    const [resortRoom,setResortRoom] = React.useState(resort?.rooms && resort?.rooms.length > 0 ? resort?.rooms[0] : null);
  function formatTime(time) {
    if (!time) return "--:--"; // or return ""

    let [h, m] = time.split(":");
    h = Number(h);

    const period = h >= 12 ? "PM" : "AM";
    h = h % 12 || 12;

    return `${h}:${m} ${period}`;
  }
  const hasThumbnails = resort?.featured_images?.length > 1;
  return (
    <motion.div
      className="resortcard-container"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={{ scale: 1.02 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      {/* Left Image Section */}


<div className="resortcard-left">
  <div
    className={`resortcard-main-div-img ${
      hasThumbnails ? "half-height" : "full-height"
    }`}
  >
    <motion.img
      src={resort?.featured_image || noimg}
      alt={resort?.name}
      className="resortcard-main-img"
    />
  </div>

  {hasThumbnails && (
    <div className="resortcard-thumbnails">
      {resort.featured_images.slice(1, 3).map((img, idx) => (
        <motion.img
          key={idx}
          src={img || noimg}
          className="resortcard-thumb"
        />
      ))}
    </div>
  )}
</div>


      {/* Middle Content */}
      <div className="resortcard-middle">
        <h2 className="resortcard-title">{resort?.name}</h2><span className="resort-rating">
  {resort?.average_rating ? resort.average_rating.toFixed(1) : 0} ⭐
</span>
        <p className="resortcard-location">
          <span className="resortcard-location-highlight">
            {resort?.location}
          </span>{" "}
          | {resort?.distance}
        </p>
        <p className="resortcard-description"><SafeComponent html={resort?.description}/></p>

        {/* Highlights */}
<div className="resortcard-highlights-container" style={{ display: 'flex', gap: '20px' }}>
  {/* Left Column: first 4 items */}
  <ul className="resortcard-highlights" style={{ flex: 1 }}>
    {resort?.amenities?.slice(0, 4).map((item, i) => (
      <motion.li
        key={i}
        className="resortcard-highlight"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: i * 0.1 }}
      >
        ✅ {item.name}
      </motion.li>
    ))}
  </ul>

  {/* Right Column: remaining items */}
  <ul className="resortcard-highlights" style={{ flex: 1 }}>
    {resort?.amenities?.slice(4).map((item, i) => (
      <motion.li
        key={i + 4}
        className="resortcard-highlight"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: i * 0.1 }}
      >
        ✅ {item.name}
      </motion.li>
    ))}
  </ul>
</div>

      </div>

      {/* Right Price Section */}
      <motion.div
        className="resortcard-right"
        initial={{ opacity: 0, x: 40 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div style={{position:"absolute",top:"2px",background: "#965f15",color:"white",width:"100%",fontWeight:"600"}}>Start Check In : {formatTime(resort?.check_in_time)}</div>

        <h3 className="resortcard-price">
          {resortRoom?.price_per_night || resortRoom?.pricing?.per_night?.base} / <span>Per night</span>
        </h3>
        <p className="resortcard-tax">+ ₹{resort?.taxes} taxes per night</p>

        <motion.button
          className="resortcard-btn"
          whileHover={{ scale: 1.05, backgroundColor: "#facc15" }}
          whileTap={{ scale: 0.95 }}
          onClick={()=>navigate(`/hotel/${resort.id}`)}
        >
          View Details
        </motion.button>

        <div style={{position:"absolute",bottom:"2px",background: "#965f15",color:"white",width:"100%",fontWeight:"600"}}>Last Check Out : {formatTime(resort?.check_out_time)}</div>
      </motion.div>
    </motion.div>
  );
};

export default ResortCard;
